import { Component } from '@angular/core';
import { faLink } from '@fortawesome/free-solid-svg-icons';

@Component({
  standalone: false,
  selector: 'app-home-content',
  templateUrl: './home-content.component.html',
  styleUrls: ['./home-content.component.css']
})
export class HomeContentComponent {
  faLink = faLink;
}
